<template>
    <div class="mb-1">
        <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1 mb-1"
            :disabled="!listReady || assigning || !products.length"
            @click="selectPage"
        >
            Sayfadakilerin tümünü seç
        </b-button>
        <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1 mb-1"
            :disabled="!listReady || assigning || !pagination || !pagination.total"
            @click="$store.commit('tyManagement/selectAllProducts')"
        >
            Tüm sayfalardakileri seç
        </b-button>
        <b-button
            size="sm"
            variant="outline-secondary"
            class="mr-1 mb-1"
            :disabled="assigning || !selectedCount"
            @click="$store.commit('tyManagement/clearSelection')"
        >
            Seçimi temizle
        </b-button>
        <p
            class="mb-0"
            role="status"
            aria-live="polite"
        >
            {{ selectedCount }} ürün seçili.
            <span v-if="allSelected">Tüm sayfalardaki ürünler seçili; işaretini kaldırdığınız ürünler atanmaz.</span>
            <span v-else>Seçimleriniz sayfa değiştirirken korunur.</span>
            Filtre değiştirildiğinde seçim temizlenir.
        </p>
    </div>
</template>
<script>
    import { mapState, mapGetters } from 'vuex'
    import { BButton } from 'bootstrap-vue'

    export default {
        components: { BButton },
        computed: {
            ...mapState('tyManagement', ['products', 'pagination', 'listReady', 'allSelected', 'assigning']),
            ...mapGetters('tyManagement', ['selectedCount']),
        },
        methods: {
            selectPage() {
                this.$store.commit('tyManagement/setProductSelection', { ids: this.products.map(product => product.id), selected: true })
            },
        },
    }
</script>
